"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum;
(function (TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum) {
    TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum["Integer"] = "DT_INTEGER";
    TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum["Real"] = "DT_REAL";
    TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum["String"] = "DT_STRING";
    TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum["Datetime"] = "DT_DATETIME";
    TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum["Boolean"] = "DT_BOOLEAN";
    TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum["Date"] = "DT_DATE";
    TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum["Spatial"] = "DT_SPATIAL";
    TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum["Unknown"] = "DT_UNKNOWN";
})(TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum = exports.TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum || (exports.TableauPublishedconnectionV1ColumnImmutablePropertiesPhysicalColumnDataTypeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum;
(function (TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum) {
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Empty"] = "RDT_EMPTY";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Null"] = "RDT_NULL";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["I2"] = "RDT_I2";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["I4"] = "RDT_I4";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["R4"] = "RDT_R4";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["R8"] = "RDT_R8";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Cy"] = "RDT_CY";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Date"] = "RDT_DATE";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Bstr"] = "RDT_BSTR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Idispatch"] = "RDT_IDISPATCH";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Error"] = "RDT_ERROR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Bool"] = "RDT_BOOL";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Variant"] = "RDT_VARIANT";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Iunknown"] = "RDT_IUNKNOWN";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Decimal"] = "RDT_DECIMAL";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Ui1"] = "RDT_UI1";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Array"] = "RDT_ARRAY";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Byref"] = "RDT_BYREF";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["I1"] = "RDT_I1";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Ui2"] = "RDT_UI2";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Ui4"] = "RDT_UI4";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["I8"] = "RDT_I8";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Ui8"] = "RDT_UI8";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Guid"] = "RDT_GUID";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Vector"] = "RDT_VECTOR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Filetime"] = "RDT_FILETIME";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Reserved"] = "RDT_RESERVED";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Bytes"] = "RDT_BYTES";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Str"] = "RDT_STR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Wstr"] = "RDT_WSTR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Numeric"] = "RDT_NUMERIC";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Udt"] = "RDT_UDT";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Dbdate"] = "RDT_DBDATE";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Dbtime"] = "RDT_DBTIME";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Dbtimestamp"] = "RDT_DBTIMESTAMP";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Hchapter"] = "RDT_HCHAPTER";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Propvariant"] = "RDT_PROPVARIANT";
    TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum["Varnumeric"] = "RDT_VARNUMERIC";
})(TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum = exports.TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum || (exports.TableauPublishedconnectionV1ColumnImmutablePropertiesRemoteTypeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum;
(function (TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum) {
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Sum"] = "AT_SUM";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Avg"] = "AT_AVG";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Min"] = "AT_MIN";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Max"] = "AT_MAX";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Stdev"] = "AT_STDEV";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Stdevp"] = "AT_STDEVP";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Var"] = "AT_VAR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Varp"] = "AT_VARP";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Count"] = "AT_COUNT";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Countd"] = "AT_COUNTD";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Median"] = "AT_MEDIAN";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Attr"] = "AT_ATTR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["None"] = "AT_NONE";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Percentile"] = "AT_PERCENTILE";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Year"] = "AT_YEAR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Qtr"] = "AT_QTR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Month"] = "AT_MONTH";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Day"] = "AT_DAY";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Hour"] = "AT_HOUR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Minute"] = "AT_MINUTE";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Second"] = "AT_SECOND";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Week"] = "AT_WEEK";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Weekday"] = "AT_WEEKDAY";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Monthyear"] = "AT_MONTHYEAR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Mdy"] = "AT_MDY";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["End"] = "AT_END";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Isoyear"] = "AT_ISOYEAR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Isoqtr"] = "AT_ISOQTR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Isoweek"] = "AT_ISOWEEK";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Isoweekday"] = "AT_ISOWEEKDAY";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncyear"] = "AT_TRUNCYEAR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncqtr"] = "AT_TRUNCQTR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncmonth"] = "AT_TRUNCMONTH";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncweek"] = "AT_TRUNCWEEK";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncday"] = "AT_TRUNCDAY";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Trunchour"] = "AT_TRUNCHOUR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncminute"] = "AT_TRUNCMINUTE";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncsecond"] = "AT_TRUNCSECOND";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncisoyear"] = "AT_TRUNCISOYEAR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncisoqtr"] = "AT_TRUNCISOQTR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncisoweek"] = "AT_TRUNCISOWEEK";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Truncisoweekday"] = "AT_TRUNCISOWEEKDAY";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Quart1"] = "AT_QUART1";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Quart3"] = "AT_QUART3";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Skewness"] = "AT_SKEWNESS";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Kurtosis"] = "AT_KURTOSIS";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Inout"] = "AT_INOUT";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Sumxsqr"] = "AT_SUMXSQR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["User"] = "AT_USER";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Collect"] = "AT_COLLECT";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Covar"] = "AT_COVAR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Covarp"] = "AT_COVARP";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Corr"] = "AT_CORR";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Downgraded"] = "AT_DOWNGRADED";
    TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum["Concatenate"] = "AT_CONCATENATE";
})(TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum = exports.TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum || (exports.TableauPublishedconnectionV1ColumnImmutablePropertiesAggTypeEnum = {}));
function TableauPublishedconnectionV1ColumnImmutablePropertiesFromJSON(json) {
    return TableauPublishedconnectionV1ColumnImmutablePropertiesFromJSONTyped(json, false);
}
exports.TableauPublishedconnectionV1ColumnImmutablePropertiesFromJSON = TableauPublishedconnectionV1ColumnImmutablePropertiesFromJSON;
function TableauPublishedconnectionV1ColumnImmutablePropertiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'physicalColumnDataType': !runtime_1.exists(json, 'physical_column_data_type') ? undefined : json['physical_column_data_type'],
        'primaryKey': !runtime_1.exists(json, 'primary_key') ? undefined : json['primary_key'],
        'primaryKeyTableName': !runtime_1.exists(json, 'primary_key_table_name') ? undefined : json['primary_key_table_name'],
        'primaryKeyFieldName': !runtime_1.exists(json, 'primary_key_field_name') ? undefined : json['primary_key_field_name'],
        'collation': !runtime_1.exists(json, 'collation') ? undefined : json['collation'],
        'width': !runtime_1.exists(json, 'width') ? undefined : json['width'],
        'remoteType': !runtime_1.exists(json, 'remote_type') ? undefined : json['remote_type'],
        'aggType': !runtime_1.exists(json, 'agg_type') ? undefined : json['agg_type'],
        'ordinal': !runtime_1.exists(json, 'ordinal') ? undefined : json['ordinal'],
    };
}
exports.TableauPublishedconnectionV1ColumnImmutablePropertiesFromJSONTyped = TableauPublishedconnectionV1ColumnImmutablePropertiesFromJSONTyped;
function TableauPublishedconnectionV1ColumnImmutablePropertiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'physical_column_data_type': value.physicalColumnDataType,
        'primary_key': value.primaryKey,
        'primary_key_table_name': value.primaryKeyTableName,
        'primary_key_field_name': value.primaryKeyFieldName,
        'collation': value.collation,
        'width': value.width,
        'remote_type': value.remoteType,
        'agg_type': value.aggType,
        'ordinal': value.ordinal,
    };
}
exports.TableauPublishedconnectionV1ColumnImmutablePropertiesToJSON = TableauPublishedconnectionV1ColumnImmutablePropertiesToJSON;
